export interface CategoryMeta {
  name: string;
  slug: string;
  title: string;
  description: string;
  keywords: string;
  faqs?: Array<{ question: string; answer: string }>;
}

export const CATEGORY_META: Record<string, CategoryMeta> = {
  'finanzen-karten': {
    name: 'Finanzen & Karten',
    slug: 'finanzen-karten',
    title: 'Kreditkarten Gutscheine & Prämien 2026',
    description: 'Entdecke exklusive Kreditkarten-Angebote, Willkommensprämien bis zu 85.000 Punkte und dauerhaft gebührenfreie Karten wie American Express und Gebührenfrei Mastercard.',
    keywords: 'Kreditkarte Prämie, American Express Platinum Punkte, Gebührenfrei Mastercard, Finanzen Deals, Kreditkarten Vergleich 2026',
    faqs: [
      {
        question: 'Wie erhalte ich die Willkommensprämien bei Kreditkarten?',
        answer: 'Nutze den offiziellen Einladungslink auf unserer Seite, um deinen Antrag direkt beim Kartenanbieter abzuschließen. Die Punkte oder das Startguthaben werden nach Kartenausstellung und Erfüllung der Aktionsbedingungen gutgeschrieben.'
      },
      {
        question: 'Fallen für die Nutzung der Gutscheine Kosten an?',
        answer: 'Nein, alle Einladungslinks und Gutscheincodes auf Coupon Showcase sind 100% kostenlos und unverbindlich.'
      }
    ]
  },
  'food-delivery': {
    name: 'Food & Delivery',
    slug: 'food-delivery',
    title: 'Food & Delivery Gutscheine & Rabattcodes 2026',
    description: 'Spare bei deinen Essensbestellungen und Kochboxen mit aktuellen Gutscheinen für Uber Eats, HelloFresh, Gorillas und mehr.',
    keywords: 'Uber Eats Gutschein, HelloFresh Rabattcode, Food Delivery Rabatte, Essen bestellen Gutschein 2026',
    faqs: [
      {
        question: 'Wie löse ich einen Lieferdienst-Gutscheincode ein?',
        answer: 'Kopiere einfach den Gutscheincode auf unserer Seite und füge ihn beim Bezahlvorgang in der App oder auf der Website des Lieferdienstes ein.'
      },
      {
        question: 'Gelten die Food-Gutscheine auch für Bestandskunden?',
        answer: 'Die meisten Codes bieten Neukunden erhebliche Rabatte (z.B. 15€ oder eine Woche gratis). Einige Partner bieten auch wiederkehrende Aktionen für Bestandskunden an.'
      }
    ]
  },
  'mobilitaet': {
    name: 'Mobilität',
    slug: 'mobilitaet',
    title: 'Mobilität & E-Scooter Gutscheine 2026',
    description: 'Sichere dir Freifahrten, Fahrtguthaben und Rabatte für E-Scooter, Fahrdienste und Taxis bei FREE NOW, Tier und Voi.',
    keywords: 'E-Scooter Freifahrten, FREE NOW Gutschein, Tier Promo Code, Voi Guthaben, Mobilität Rabatt 2026',
    faqs: [
      {
        question: 'Wie erhalte ich mein E-Scooter Startguthaben?',
        answer: 'Klicke auf den Einladungslink, lade die jeweilige App herunter oder gib den Gutscheincode in deinem Nutzerprofil unter Gutscheine ein.'
      }
    ]
  },
  'finanzen-banking': {
    name: 'Finanzen & Banking',
    slug: 'finanzen-banking',
    title: 'Girokonto & Banking Prämien 2026',
    description: 'Finde die besten kostenlosen Girokonten mit Startguthaben und Empfehlungsboni bei Top-Banken wie N26 und DKB.',
    keywords: 'Girokonto Startguthaben, N26 Bonus, DKB Prämie, Kostenloses Girokonto 2026, Neobank Bonus',
    faqs: [
      {
        question: 'Welche Voraussetzungen gibt es für das Startguthaben?',
        answer: 'In der Regel reicht eine kostenlose Kontoeröffnung über den Aktionslink und eine erste Kartenzahlung oder der Eingang der ersten Überweisung.'
      }
    ]
  },
  'fitness-sport': {
    name: 'Fitness & Sport',
    slug: 'fitness-sport',
    title: 'Fitness & Sport Rabattcodes 2026',
    description: 'Spare bei deiner Fitness-Mitgliedschaft und Sportangeboten mit exklusiven Rabatten für Urban Sports Club und mehr.',
    keywords: 'Urban Sports Club Rabatt, Fitness Gutschein, Sport Mitgliedschaft Rabattcode 2026',
    faqs: [
      {
        question: 'Wie löse ich den Urban Sports Club Rabatt ein?',
        answer: 'Gib den angegebenen Promo-Code direkt bei der Online-Anmeldung auf der Website von Urban Sports Club ein.'
      }
    ]
  },
  'tech-miete': {
    name: 'Tech & Miete',
    slug: 'tech-miete',
    title: 'Tech & Miete Gutscheine 2026',
    description: 'Miete Smartphones, Laptops, Kameras und Gaming-Equipment flexibel und spare mit exklusivem Grover Cash Startguthaben.',
    keywords: 'Grover Gutschein, Technik mieten Rabatt, Grover Cash Bonus, Tech Deals 2026',
    faqs: [
      {
        question: 'Wie funktioniert der 20€ Grover Cash Bonus?',
        answer: 'Nach deiner ersten Gerätemiete über den Empfehlungslink wird dir und dem Werber jeweils 20€ Guthaben auf das Grover-Konto gutgeschrieben.'
      }
    ]
  },
  'bildung-sprachen': {
    name: 'Bildung & Sprachen',
    slug: 'bildung-sprachen',
    title: 'Bildung & Sprachkurse Rabatte 2026',
    description: 'Lerne neue Sprachen online und erhalte Gratismonate und Rabatte für führende Lernplattformen wie Babbel.',
    keywords: 'Babbel Gutschein, Sprachen lernen Rabatt, Babbel Gratismonate, Online Sprachkurs Rabattcode 2026',
    faqs: [
      {
        question: 'Wie erhalte ich die 3 Gratismonate bei Babbel?',
        answer: 'Nutze einfach unseren offiziellen Babbel-Einladungslink bei der Registrierung und beim Abschluss deines ersten Abonnements.'
      }
    ]
  }
};

export const slugifyCategory = (categoryName: string): string => {
  return categoryName
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .replace(/&/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};

export const getCategoryBySlug = (slug: string): CategoryMeta | undefined => {
  if (CATEGORY_META[slug]) {
    return CATEGORY_META[slug];
  }
  // Fallback match by computed slug
  const entry = Object.values(CATEGORY_META).find(c => c.slug === slug || slugifyCategory(c.name) === slug);
  return entry;
};
